module.exports = __webpack_public_path__ + "img/9788989485896.0052ce77.jpg";